import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import * as i2 from 'file-upload-library';
import * as i3 from 'primeng/table';
import * as i4 from 'primeng/api';
import * as i5 from '@angular/common';
import * as i6 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';

class LibViewProjectService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getViewProjectDetails(Id) {
        return this.http.get(`/vd/formBuilder/get/projectTimesheet/${Id}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibViewProjectService.ɵfac = function LibViewProjectService_Factory(t) { return new (t || LibViewProjectService)(i0.ɵɵinject(i1.HttpClient)); };
LibViewProjectService.ɵprov = i0.ɵɵdefineInjectable({ token: LibViewProjectService, factory: LibViewProjectService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewProjectService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LibViewProjectComponent_ng_template_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 11);
    i0.ɵɵtext(2, "Department");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 11);
    i0.ɵɵtext(4, "Employee Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 11);
    i0.ɵɵtext(6, "Hourly Rate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewProjectComponent_ng_template_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employeeListOfProject_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(employeeListOfProject_r3.departmentName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(employeeListOfProject_r3.employeeName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(employeeListOfProject_r3.hourlyRate);
} }
function LibViewProjectComponent_div_58_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Document Category");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewProjectComponent_div_58_ng_template_8_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵlistener("click", function LibViewProjectComponent_div_58_ng_template_8_div_8_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r11); const loadData_r7 = i0.ɵɵnextContext().$implicit; const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.openDoc(loadData_r7); });
    i0.ɵɵelementStart(3, "mat-icon", 24);
    i0.ɵɵtext(4, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelementStart(6, "i", 26);
    i0.ɵɵlistener("click", function LibViewProjectComponent_div_58_ng_template_8_div_8_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r11); const loadData_r7 = i0.ɵɵnextContext().$implicit; const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.download(loadData_r7); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewProjectComponent_div_58_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "p", 19);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtemplate(8, LibViewProjectComponent_div_58_ng_template_8_div_8_Template, 7, 0, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loadData_r7 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loadData_r7 == null ? null : loadData_r7.fileName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loadData_r7 == null ? null : loadData_r7.documentCategory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", loadData_r7.fileName !== null);
} }
function LibViewProjectComponent_div_58_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, " No records found ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 3);
} }
function LibViewProjectComponent_div_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "h6", 14);
    i0.ɵɵtext(3, "Uploaded Files");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵelementStart(6, "p-table", 17);
    i0.ɵɵtemplate(7, LibViewProjectComponent_div_58_ng_template_7_Template, 7, 0, "ng-template", 8);
    i0.ɵɵtemplate(8, LibViewProjectComponent_div_58_ng_template_8_Template, 9, 3, "ng-template", 9);
    i0.ɵɵtemplate(9, LibViewProjectComponent_div_58_ng_template_9_Template, 3, 1, "ng-template", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", ctx_r2.viewProjectDetails == null ? null : ctx_r2.viewProjectDetails.files)("resizableColumns", true);
} }
class LibViewProjectComponent {
    constructor(viewProjectService, uploadService) {
        this.viewProjectService = viewProjectService;
        this.uploadService = uploadService;
        this.observableSubscription$ = new Subject();
        this.viewProjectDetails = [];
        this.employeeListOfProject = [];
    }
    ngOnInit() {
        this.getViewProjectDetails();
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    }
    getViewProjectDetails() {
        this.getListId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
        if (this.getListId) {
            this.viewProjectService.getViewProjectDetails(this.getListId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                this.viewProjectDetails = response.data || null;
                this.employeeListOfProject = this.viewProjectDetails.employeeListOfProject;
            });
        }
    }
    openDoc(item) {
        var _a;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl;
        const docPath = (_a = item.docPath) === null || _a === void 0 ? void 0 : _a.substring(9);
        window.open(`${baseUrl}/${docPath}`, '_blank');
    }
    download(file) {
        var _a, _b, _c;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl + '/';
        this.uploadService.downloadDocuments(baseUrl + ((_a = file.docPath) === null || _a === void 0 ? void 0 : _a.substring(9)), this.isFBUser ? (_b = file.docPath) === null || _b === void 0 ? void 0 : _b.split('/').slice(-1)[0] : (_c = file.docPath) === null || _c === void 0 ? void 0 : _c.substring(9));
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LibViewProjectComponent.ɵfac = function LibViewProjectComponent_Factory(t) { return new (t || LibViewProjectComponent)(i0.ɵɵdirectiveInject(LibViewProjectService), i0.ɵɵdirectiveInject(i2.FileUploadLibraryService)); };
LibViewProjectComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibViewProjectComponent, selectors: [["lib-view-project"]], decls: 59, vars: 12, consts: [[1, "container-fluid", "correction-summary", "p-0", "mt-2", "mb-2", "pb-3"], [1, "row"], [1, "col-3"], [1, "summary_details_content", "m-0"], [1, "summary_details_heading", "mb-2"], [1, "row", "mt-2"], [1, "row", "mt-2", "employee-table"], ["tableStyleClass", "employee-table", 1, "table-striped-simple", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["class", "files-section", 4, "ngIf"], ["scope", "col"], [1, "files-section"], [1, "col-12", "positionHeading"], [1, "file-heading"], [1, "uploadedDocumentSection"], [1, "row", "mt-2", "p-0", "pb-3"], ["styleClass", "table-striped-simple", 3, "value", "resizableColumns"], ["pTemplate", "emptymessage"], [1, "file-type"], ["class", "row file-icons", 4, "ngIf"], [1, "row", "file-icons"], [1, "mr-2", "padding0"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons", "icon-color"], [1, "download-icon"], ["title", "Download", 1, "fa", "fa-download", "pr-2", "icn", "icon-color", 3, "click"]], template: function LibViewProjectComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4, " Project Type ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵelementStart(8, "p", 3);
        i0.ɵɵtext(9, " Project Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "p", 4);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 2);
        i0.ɵɵelementStart(13, "p", 3);
        i0.ɵɵtext(14, " Client ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "p", 4);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 2);
        i0.ɵɵelementStart(18, "p", 3);
        i0.ɵɵtext(19, " Created On ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "p", 4);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 5);
        i0.ɵɵelementStart(23, "div", 2);
        i0.ɵɵelementStart(24, "p", 3);
        i0.ɵɵtext(25, " Hourly Rate ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "p", 4);
        i0.ɵɵtext(27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 2);
        i0.ɵɵelementStart(29, "p", 3);
        i0.ɵɵtext(30, " Project Manager ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "p", 4);
        i0.ɵɵtext(32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 2);
        i0.ɵɵelementStart(34, "p", 3);
        i0.ɵɵtext(35, " No. of Resources ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "p", 4);
        i0.ɵɵtext(37);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 2);
        i0.ɵɵelementStart(39, "p", 3);
        i0.ɵɵtext(40, " Time estimates hours ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "p", 4);
        i0.ɵɵtext(42);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 5);
        i0.ɵɵelementStart(44, "div", 2);
        i0.ɵɵelementStart(45, "p", 3);
        i0.ɵɵtext(46, " Project Start date ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "p", 4);
        i0.ɵɵtext(48);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 2);
        i0.ɵɵelementStart(50, "p", 3);
        i0.ɵɵtext(51, " Project End Date ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "p", 4);
        i0.ɵɵtext(53);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "div", 6);
        i0.ɵɵelementStart(55, "p-table", 7);
        i0.ɵɵtemplate(56, LibViewProjectComponent_ng_template_56_Template, 7, 0, "ng-template", 8);
        i0.ɵɵtemplate(57, LibViewProjectComponent_ng_template_57_Template, 7, 3, "ng-template", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(58, LibViewProjectComponent_div_58_Template, 10, 2, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectType) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectType : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectName) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.clientName) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.clientName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.createdOn) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.createdOn : "--", " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.hourlyRate) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.hourlyRate : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectManagerName) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectManagerName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.noOfResources) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.noOfResources : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.estimatedHours) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.estimatedHours : "--", " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectStartDate) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectStartDate : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectEndDate) ? ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.projectEndDate : "--", " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("value", ctx.employeeListOfProject);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.viewProjectDetails == null ? null : ctx.viewProjectDetails.files == null ? null : ctx.viewProjectDetails.files.length) > 0);
    } }, directives: [i3.Table, i4.PrimeTemplate, i5.NgIf, i6.MatIcon], styles: [".employee-table[_ngcontent-%COMP%]{margin-bottom:14px;width:100%}.icon-color[_ngcontent-%COMP%]{color:#2196f3!important}.files-section[_ngcontent-%COMP%]{margin-top:32px}.download-icon[_ngcontent-%COMP%]{position:relative;top:2px;left:8px}.file-heading[_ngcontent-%COMP%]{font-weight:600}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewProjectComponent, [{
        type: Component,
        args: [{
                selector: 'lib-view-project',
                templateUrl: 'lib-view-project.component.html',
                styleUrls: ['lib-view-project.component.scss']
            }]
    }], function () { return [{ type: LibViewProjectService }, { type: i2.FileUploadLibraryService }]; }, null); })();

class LibViewProjectModule {
}
LibViewProjectModule.ɵfac = function LibViewProjectModule_Factory(t) { return new (t || LibViewProjectModule)(); };
LibViewProjectModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibViewProjectModule });
LibViewProjectModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibViewProjectModule, { declarations: [LibViewProjectComponent], imports: [PrimengLibraryModule], exports: [LibViewProjectComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewProjectModule, [{
        type: NgModule,
        args: [{
                declarations: [LibViewProjectComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [LibViewProjectComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-view-project
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibViewProjectComponent, LibViewProjectModule, LibViewProjectService };
//# sourceMappingURL=lib-view-project.js.map
